/**
 * @fileoverview POST handler for the "/apps/app_groups" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupsCacheKeys } from "./constants";
import type { PostAppsAppGroupsProps, postWorkspacesResult } from "./types";

export const postWorkspaces = reactQueryMutationAdapter(
  appsAppGroupsCacheKeys,
  (props: PostAppsAppGroupsProps): Promise<postWorkspacesResult> => {
    return fetch("/apps/app_groups", "POST", props);
  }
);
